import { Booth } from "src/components/Booth";

export default {
    background: "https://assets.swoogo.com/uploads/full/3027223-65242cdf6a2ef.png?v=2",
    links: [
        {
            label: "Previous Room",
            href: "/exhibition-hall-gold",
            width: "16%",
            height: "7%",
            left: "24.3%",
            top: "90%",
        },
        {
            label: "Back To Main Hall",
            href: "/exhibition-hall",
            width: "17.4%",
            height: "7%",
            left: "41.3%",
            top: "90%",
        },
        {
            label: "Next Room",
            href: "/exhibition-hall-diamond",
            width: "16.4%",
            height: "7%",
            left: "59.3%",
            top: "90%",
        },
    ],
    extras: <>
        <Booth position={{
            width: "36.3%",
            left: "6.8%",
            top: "6.6%",
        }} boothId="f83ad5ae-9b51-425a-af32-7b3e837456c5" />
        <Booth position={{
            width: "36.3%",
            left: "56.8%",
            top: "6.6%",
        }} boothId="711b19d3-6252-4b7b-8519-8f4388985646" />
        <Booth position={{
            width: "36.1%",
            left: "6.8%",
            top: "45.6%",
        }} boothId="38b702ce-6dfb-443b-a43c-ec578d3d99d2" />
        <Booth position={{
            width: "36.1%",
            left: "56.8%",
            top: "45.6%",
        }} boothId="e17d6c04-0982-482e-ad7f-9e2b09ae5b7b" />
    </>,
    name: "exhibition-hall-silver-bronze",
}